import React, { ReactNode } from 'react'

import { useViewTracking } from 'hooks/useViewTracking'

export const ViewTracking = ({ children, viewTrackingName }: { children: ReactNode; viewTrackingName: string }) => {
    useViewTracking(viewTrackingName)

    return <>{children}</>
}
